export const scrollToAnchor = () => {
  const { hash } = window.location
  const elementToScroll = document.getElementById(hash?.replace("#", ""))
  if (!elementToScroll) return
  elementToScroll.scrollIntoView({ behavior: "smooth" })
}
